/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForRackspace extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForRackspace");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForRackspace.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForRackspace>): ServiceAccountNativeDetailsForRackspace {
        let obj = Object.assign(new ServiceAccountNativeDetailsForRackspace(), model);
        ServiceAccountNativeDetailsForRackspace.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForRackspace>): ServiceAccountNativeDetailsForRackspace {
        if (!model) return null;
        return ServiceAccountNativeDetailsForRackspace.newInstance(<ServiceAccountNativeDetailsForRackspace> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForRackspace) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForRackspace.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForRackspace): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForRackspace.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
